import React, { useContext } from 'react';
import { ClientSideDataGrid } from 'src/components/CaseListTable';
import Spacer from 'src/components/Layout/Spacer';
import { fetchFromAppConfig } from 'src/config-store/ConfigFetcher';
import { CONFIG_TYPE, UI_CLIENTS } from 'src/constants/GlobalConstants';
import {
  CaseListConstants,
  CreateCaseConstants,
} from 'src/constants/ProjectConstants';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { TranslationContext } from 'src/state/providers/TranslationProvider';
import { CaseListPageProps } from './CaseListPage';
import { getColumnsConfig } from './config/DataGridConfiguration';

export function getAllowedColums(accountId: string, clientId: UI_CLIENTS) {
  return fetchFromAppConfig(accountId, clientId, CONFIG_TYPE.CASE_LIST)
    ?.columns;
}

export const CaseListGrid: React.FC<CaseListPageProps> = ({ data }) => {
  const { preferredAccountId, clientId } = useContext(AuthContext);
  const { caseListBundle, messageBundle } = useContext(TranslationContext);

  const allowedColumns = getAllowedColums(preferredAccountId, clientId);
  return (
    <>
      <Spacer height="1rem"></Spacer>
      <h2>
        {caseListBundle.getMessage(CreateCaseConstants.CASE_LISTING_TEXT)}
      </h2>
      <ClientSideDataGrid
        key={Date.now()}
        items={data}
        columns={getColumnsConfig(new Set(allowedColumns))}
        noResultsMessage={messageBundle.getMessage(
          CaseListConstants.NO_EXISTING_CASE_PRESENT_MESSAGE,
        )}
      />
    </>
  );
};
